/**
 * Calculate pagination display values
 */
export function calculatePaginationValues(total: number, offset: number, limit: number) {
  const totalPages = Math.ceil(total / limit);
  const currentPage = Math.floor(offset / limit) + 1;
  const start = total === 0 ? 0 : offset + 1;
  const end = Math.min(offset + limit, total);

  // Generate page numbers array with ellipsis for large page counts
  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (currentPage > 3) pages.push('...');
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }

  return {
    totalPages,
    currentPage,
    start,
    end,
    hasNextPage: end < total,
    hasPreviousPage: offset > 0,
    pages,
  };
}

/**
 * Validate and redirect to last valid page if current page exceeds total
 */
export function getValidPage(currentPage: number, totalPages: number): number {
  if (totalPages === 0) return 1;
  return Math.min(currentPage, totalPages);
}
